(function () {
  if (window.QuoteList) return;

  var STORAGE_KEY = 'quote-list';

  function read() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function write(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    render();
  }

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  function add(item) {
    var items = read();
    var existing = items.find(function (i) { return i.variantId === item.variantId; });
    if (existing) {
      existing.qty += item.qty || 1;
    } else {
      item.qty = item.qty || 1;
      items.push(item);
    }
    write(items);
  }

  function addFromCart(cartItems) {
    if (!cartItems || !cartItems.length) return;
    var items = read();
    cartItems.forEach(function (item) {
      var variantId = String(item.variantId);
      var qty = Math.max(1, parseInt(item.qty, 10) || 1);
      var existing = items.find(function (i) { return i.variantId === variantId; });
      if (existing) {
        existing.qty = Math.max(existing.qty, qty);
        if (item.title) existing.title = item.title;
        if (item.variantTitle) existing.variantTitle = item.variantTitle;
        if (item.sku) existing.sku = item.sku;
        if (item.url) existing.url = item.url;
        if (item.image) existing.image = item.image;
        if (item.price) existing.price = item.price;
      } else {
        items.push({
          productId: item.productId,
          variantId: variantId,
          title: item.title,
          variantTitle: item.variantTitle || '',
          sku: item.sku || '',
          url: item.url,
          image: item.image || '',
          price: item.price || '',
          qty: qty
        });
      }
    });
    write(items);
  }

  function updateQty(variantId, qty) {
    var items = read();
    items.forEach(function (i) {
      if (i.variantId === variantId) i.qty = Math.max(1, qty);
    });
    write(items);
  }

  function remove(variantId) {
    write(read().filter(function (i) { return i.variantId !== variantId; }));
  }

  function getDrawer() {
    return document.querySelector('[data-quote-drawer]');
  }

  function showPanel(name) {
    var items = read();
    if (name === 'request' && !items.length) name = 'items';

    document.querySelectorAll('[data-quote-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-quote-panel') !== name;
    });

    var body = document.querySelector('.quote-drawer__body');
    if (body) body.scrollTop = 0;
  }

  function open() {
    var drawer = getDrawer();
    if (!drawer) return;
    if (drawer.parentElement !== document.body) document.body.appendChild(drawer);
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('quote-drawer-open');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        drawer.classList.add('is-visible');
      });
    });
  }

  function close() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.remove('is-visible');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('quote-drawer-open');
    setTimeout(function () {
      if (!drawer.classList.contains('is-visible')) drawer.classList.remove('is-open');
    }, 300);
  }

  function buildBody(items) {
    var lines = ['QUOTE REQUEST', ''];
    items.forEach(function (i, index) {
      lines.push(
        (index + 1) + '. ' + i.title + (i.variantTitle ? ' (' + i.variantTitle + ')' : '') +
        ' | Qty: ' + i.qty +
        (i.sku ? ' | SKU: ' + i.sku : '') +
        (i.price ? ' | Price: ' + i.price + ' ex GST' : '') +
        ' | ' + window.location.origin + i.url
      );
    });
    return lines.join('\n');
  }

  function render() {
    var items = read();
    var count = items.reduce(function (sum, i) { return sum + i.qty; }, 0);

    document.querySelectorAll('[data-quote-count]').forEach(function (el) {
      el.textContent = count;
    });
    var success = document.querySelector('[data-quote-success]');
    document.querySelectorAll('[data-quote-open]').forEach(function (el) {
      el.hidden = items.length === 0 && !(success && !success.hidden);
    });

    document.querySelectorAll('[data-quote-add]').forEach(function (btn) {
      var inList = items.some(function (i) { return i.variantId === String(currentVariantId(btn)); });
      btn.classList.toggle('is-added', inList);
      var text = btn.querySelector('[data-quote-add-text]');
      if (text) text.textContent = inList ? 'Added to Quote' : 'Add to Quote';
    });

    var list = document.querySelector('[data-quote-list]');
    var empty = document.querySelector('[data-quote-empty]');
    var fields = document.querySelector('[data-quote-fields]');
    var actions = document.querySelector('[data-quote-item-actions]');
    if (!list) return;

    empty.hidden = items.length > 0;
    if (fields) fields.hidden = items.length === 0;
    if (actions) actions.hidden = items.length === 0;

    var requestPanel = document.querySelector('[data-quote-panel="request"]');
    if (requestPanel && !requestPanel.hidden && !items.length) showPanel('items');

    list.innerHTML = items.map(function (i) {
      return (
        '<li class="quote-item" data-variant-id="' + escapeHtml(i.variantId) + '">' +
          (i.image ? '<img class="quote-item__img" src="' + escapeHtml(i.image) + '" alt="" loading="lazy">' : '') +
          '<div class="quote-item__info">' +
            '<a class="quote-item__title" href="' + escapeHtml(i.url) + '">' + escapeHtml(i.title) + '</a>' +
            (i.variantTitle ? '<div class="quote-item__meta">' + escapeHtml(i.variantTitle) + '</div>' : '') +
            (i.sku ? '<div class="quote-item__meta">SKU: ' + escapeHtml(i.sku) + '</div>' : '') +
            '<div class="quote-item__actions">' +
              '<button type="button" data-quote-qty="-1" aria-label="Decrease quantity">&minus;</button>' +
              '<input type="number" min="1" value="' + i.qty + '" data-quote-qty-input aria-label="Quantity">' +
              '<button type="button" data-quote-qty="1" aria-label="Increase quantity">+</button>' +
              '<button type="button" class="quote-item__remove" data-quote-remove>Remove</button>' +
            '</div>' +
          '</div>' +
        '</li>'
      );
    }).join('');
  }

  function currentVariantId(btn) {
    var formId = btn.getAttribute('data-form-id');
    if (formId) {
      var input = document.querySelector('#' + CSS.escape(formId) + ' [name="id"]') ||
        document.querySelector('[form="' + formId + '"][name="id"]');
      if (input && input.value) return input.value;
    }
    return btn.getAttribute('data-variant-id');
  }

  document.addEventListener('click', function (event) {
    var cartQuoteBtn = event.target.closest('[data-quote-from-cart]');
    if (cartQuoteBtn) {
      event.preventDefault();
      event.stopPropagation();
      var payload = cartQuoteBtn.getAttribute('data-quote-from-cart');
      var cartItems = [];
      try {
        cartItems = JSON.parse(payload || '[]');
      } catch (e) {
        cartItems = [];
      }
      addFromCart(cartItems);
      showPanel('request');
      open();
      return;
    }

    var addBtn = event.target.closest('[data-quote-add]');
    if (addBtn) {
      event.preventDefault();
      event.stopPropagation();
      add({
        productId: addBtn.getAttribute('data-product-id'),
        variantId: String(currentVariantId(addBtn)),
        title: addBtn.getAttribute('data-title'),
        variantTitle: addBtn.getAttribute('data-variant-title'),
        sku: addBtn.getAttribute('data-sku'),
        url: addBtn.getAttribute('data-url'),
        image: addBtn.getAttribute('data-image'),
        price: addBtn.getAttribute('data-price')
      });
      showPanel('items');
      open();
      return;
    }

    var tab = event.target.closest('[data-quote-tab]');
    if (tab) {
      event.preventDefault();
      showPanel(tab.getAttribute('data-quote-tab'));
      return;
    }

    if (event.target.closest('[data-quote-add-more]')) {
      event.preventDefault();
      close();
      return;
    }

    if (event.target.closest('[data-quote-go-request]')) {
      event.preventDefault();
      showPanel('request');
      return;
    }

    if (event.target.closest('[data-quote-open]')) {
      event.preventDefault();
      event.stopPropagation();
      open();
      return;
    }
    if (event.target.closest('[data-quote-close]')) {
      event.preventDefault();
      close();
      return;
    }

    var item = event.target.closest('.quote-item');
    if (!item) return;
    var variantId = item.getAttribute('data-variant-id');

    if (event.target.closest('[data-quote-remove]')) {
      remove(variantId);
      return;
    }
    var qtyBtn = event.target.closest('[data-quote-qty]');
    if (qtyBtn) {
      var input = item.querySelector('[data-quote-qty-input]');
      updateQty(variantId, (parseInt(input.value, 10) || 1) + parseInt(qtyBtn.getAttribute('data-quote-qty'), 10));
    }
  }, true);

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-quote-qty-input]');
    if (!input) return;
    var item = input.closest('.quote-item');
    updateQty(item.getAttribute('data-variant-id'), parseInt(input.value, 10) || 1);
  });

  document.addEventListener('submit', function (event) {
    if (event.target.id !== 'QuoteRequestForm') return;
    var items = read();
    if (!items.length) {
      event.preventDefault();
      return;
    }
    var message = event.target.querySelector('[name="contact[message]"]');
    var body = buildBody(items) + (message && message.value ? '\n\nMessage:\n' + message.value : '');
    event.target.querySelector('[data-quote-body]').value = body;
    sessionStorage.setItem('quote-submitted', '1');
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') close();
  });

  function init() {
    var drawer = getDrawer();
    if (drawer && drawer.parentElement !== document.body) document.body.appendChild(drawer);
    var floatBtn = document.querySelector('.quote-float-btn');
    if (floatBtn && floatBtn.parentElement !== document.body) document.body.appendChild(floatBtn);

    var submitted = sessionStorage.getItem('quote-submitted') === '1';
    sessionStorage.removeItem('quote-submitted');

    if (submitted && window.location.search.indexOf('contact_posted=true') !== -1) {
      localStorage.removeItem(STORAGE_KEY);
      var success = document.querySelector('[data-quote-success]');
      if (success) success.hidden = false;
      render();
      showPanel('request');
      open();
      return;
    }

    render();
    var error = document.querySelector('[data-quote-error]');
    if (submitted && error) {
      error.hidden = false;
      showPanel('request');
      open();
    }
  }

  window.addEventListener('storage', function (event) {
    if (event.key === STORAGE_KEY) render();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.QuoteList = { add: add, addFromCart: addFromCart, remove: remove, open: open, close: close, render: render };
})();
